import { server } from "../api";
import axios from "axios";
const GetHisoryData = async (field_id) => {
  try {
    let response = await axios.get(server + "history/data", {
      params: { field_id },
    });
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export default { GetHisoryData };
